import 'babel-polyfill'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Router, Route, browserHistory, IndexRoute } from 'react-router'
import store from './store'
import NavigationBar from './components/NavigationBar'
import Visualization from './components/Visualization'
import Footer from'./components/Footer'
import AboutUs from './components/AouutUs'
import 'react-notifications/lib/notifications.css'
import './styles/main.css'
var jsonData = require('../data/visualizationLibrary.json');
var routesList = jsonData.visualizations.map((visualization,i) =>
        <Route key={i} path={visualization.routeName} component={Visualization} />
)
const baseUrl = "/cessationStability/onlineVisualization" //Change to "/SpaghettiChart" for prod deployment

class App extends Component {
    render() {
        return (
            <div>
                <div className="header ">
                    <div className="paterTitle">{jsonData.title}</div>
                    <div><i>{jsonData.authors}</i></div>
                    <br/>
                    <div>
                        {jsonData.caption}
                        <br/>
                    </div>

                </div>
                <NavigationBar visualizations={jsonData.visualizations} />

                {this.props.children}
                <Footer />
            </div>
        )
    }
}


ReactDOM.render(
    <Provider store={store}>
        <Router history={browserHistory}>
            <Route path={baseUrl + "/"} component={App}>
                <IndexRoute component={Visualization} />
                {routesList}
                <Route path="about" component={AboutUs} />
            </Route>
        </Router>
    </Provider>, document.getElementById('container')
)



/** WEBPACK FOOTER **
 ** ./src/app.js
 **/